<template>
	<div class="breakdown">
		<div class="ui-widget-container">
			<h3 :class="[{'com-mod-module-header-individual': isIndividual}, 'com-mod-module-header']">Bonds Breakdown</h3>
			<div class="row">
				<div class="col-md-6">
					<div class="row">
						<div class="col-md-12">
							<h4 class="com-mod-section-header">Bond Details</h4>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-4">
							<div class="row">
								<div class="col-md-12">
									<img class="breakdown-chart" :src="bondBreakdownData.bondBreakdownChart">
								</div>
								<div class="col-md-12">
									<div class="chart-title">Total bond holdings</div>
								</div>
							</div>
						</div>
						<div class="col-sm-8">
							<div class="row">
								<div class="col-md-12">
									<div v-if="checkForData(bondBreakdownData.sectors)">
										<breakdown-table :module-data="bondBreakdownData.sectors">
											<template #superscript1a>
												<disclosure-superscript
													class="detail-page"
													anchor="bond_cashEquivalents"
													:statistics="['PS_CE']"
												/>
											</template>
											<template #superscript1b>
												<disclosure-superscript
													class="detail-page"
													anchor="bond_cashEquivalents"
													:statistics="['PS_CE']"
												/>
											</template>
										</breakdown-table>
										<div class="sub-info">% of net assets as of {{ bondBreakdownData.sectors.asOfDate }} (updated quarterly)</div>
									</div>
									<div v-else>
										<span class="com-mod-table-label">No bond details data is avaliable at this time.</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-6">
					<div class="row">
						<div class="col-md-12">
							<h4 class="com-mod-section-header">
								Top Fixed-Income Issuers
								<disclosure-superscript
									class="detail-page"
									anchor="bond_topFixed"
									:statistics="['TopHLD']"
								/>
							</h4>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<div v-if="checkForData(bondBreakdownData.holdings)">
								<blue-bar-table :module-data="{data: bondBreakdownData.holdings.data, includeDataField: true }"/>
								<div class="sub-info adjust-date">% of net assets as of {{ bondBreakdownData.holdings.asOfDate }} (updated monthly)</div>
							</div>
							<div v-else>
								<span class="com-mod-table-label">No top issuers data is avaliable at this time.</span>
							</div>
						</div>
						<div class="col-md-12">
							<div class="link-container">
								<i class="afis-icon-arrow-right" />
								<a :href="quarterlyHoldingsLink">
									QUARTERLY HOLDINGS
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import BreakdownTable from '_components_/global/BreakdownTable';
import BlueBarTable from '_components_/global/BlueBarTable';

export default {
	name: 'BreakdownBond',
	components: {
		BreakdownTable,
		BlueBarTable
	},
	props: {
		bondBreakdownData: {
			type: Object,
			defult: null
		}
	},
	computed: {
		...mapGetters([
			'sectorExposure_asOfDate',
			'sectorExposure_data',
			'sectorExposure_chart'
		]),
		isIndividual() {
			return this.$store.state.isIndividual;
		}
	},
	watch: {
		bondBreakdownData: {
			immediate: true,
			handler(val) {
				this.updateExcelData(val);
			}
		}
	},
	methods: {
		checkForData(arr) {
			return arr && arr.data && arr.data.length > 0;
		},
		updateExcelData(bondBreakdownData) {
			if (!bondBreakdownData) {
				bondBreakdownData = this.bondBreakdownData || {};
			}
			this.$EventBus.$emit('ExcelData', 'BondsBreakdownModule', {
				bondDetailAsOfDate: `% of net assets as of ${bondBreakdownData.sectors &&
					bondBreakdownData.sectors.asOfDate} (updated quarterly)`,
				topIssuersAsOfDate: `% of net assets as of ${bondBreakdownData.holdings &&
					bondBreakdownData.holdings.asOfDate} (updated monthly)`,
				bonds: bondBreakdownData.sectors,
				topIssuers: bondBreakdownData.holdings
			});
		}
	}
};
</script>

<style lang="less" scoped>
@import '~_css_/breakdown-module.less';
</style>
